// extracted by mini-css-extract-plugin
export default {"h1":"Title_h1__QfU7H","h5":"Title_h5__tVmD8","h6":"Title_h6__8HB-d"};